// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lobby_timer--relative[data-v-123b937b]{color:var(--color-text-maxcontrast)}.lobby_timer--timezone[data-v-123b937b]{padding-top:4px}[data-v-123b937b] .mx-input{margin:0}`, "",{"version":3,"sources":["webpack://./src/components/ConversationSettings/LobbySettings.vue"],"names":[],"mappings":"AAEC,wCACC,mCAAA,CAED,wCACC,eAAA,CAIF,4BACC,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
